var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"no-underline",attrs:{"to":_vm.getCustomLocalePath(_vm.post),"prefetch":""}},[_c('v-card',{class:{
            'card--flex-vertical': true,
            'card--featuredProducts': true,
            'justify-space-between': true,
        }},[_c('v-card-text',{class:{
                'card-text--featuredProducts': true,
                'text-center': true,
                'd-flex': true,
                'align-center': true,
            },staticStyle:{"height":"180px"}},[(
                    _vm.post.sanityThumbnail &&
                    _vm.post.sanityThumbnail.selectedImage
                )?_c('EmbedSanityImage',{attrs:{"selectedImage":_vm.post.sanityThumbnail &&
                    _vm.post.sanityThumbnail.selectedImage,"alt":_vm.post.sanityThumbnail && _vm.post.sanityThumbnail.alt,"height":"136","width":"136","classes":"align-end","img-classes":"card-img--featuredProducts","image-align":"none","fit":"fill"}}):_vm._e()],1),_vm._v(" "),_c('v-card-title',{class:{
                'card-title--featuredProducts': true,
                'text-center': true,
                squeeze: true,
            }},[_c('span',{staticClass:"no-underline nav-a--text2 card"},[_c('span',[_vm._v(_vm._s(_vm.$i18n.locale ? _vm.post.title[_vm.$i18n.locale] : _vm.post.title.en))])])]),_vm._v(" "),_c('v-card-actions',{staticClass:"card-actions--featuredProducts"},[_c('v-btn',{attrs:{"color":"primary","outlined":""}},[_c('TranslatableStringComponent',{attrs:{"tstring":{ string: 'shopNow' }}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }